import { render, staticRenderFns } from "./supplement.vue?vue&type=template&id=fd6873dc&scoped=true"
import script from "./supplement.vue?vue&type=script&lang=js"
export * from "./supplement.vue?vue&type=script&lang=js"
import style0 from "./supplement.vue?vue&type=style&index=0&id=fd6873dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6873dc",
  null
  
)

export default component.exports